import {generateVectorPosition} from '../../../../client/utils/vector-position'

class WidgetPositionImageSupport extends elementorModules.frontend.handlers.Base {
  getDefaultSettings() {
    return {
      selectors: {
        img: ".ecf-supporting .background-img-position .img-position-item",
      },
    };
  }

  getDefaultElements() {
    const selectors = this.getSettings("selectors");
    return {
      $img: this.$element.find(selectors.img),
    };
  }

  bindEvents() {
    const THIS = this;
    let ELEMENT = this.elements.$img;
    
    ELEMENT =  Array.prototype.slice.call(ELEMENT);
    if(ELEMENT.length!=0) {
        ELEMENT.forEach(item => {
          let dataPosition = item.getAttribute('data-position');
          let dataResponsive = item.getAttribute('data-responsive');
          let defaultObj = JSON.parse(atob(dataPosition))
          let responsive = JSON.parse(atob(dataResponsive))
          generateVectorPosition(defaultObj, responsive, item);
      });
    }
  }
}

jQuery(window).on("elementor/frontend/init", () => {
  const addHandler = ($element) => {
    elementorFrontend.elementsHandler.addHandler(WidgetPositionImageSupport, {
      $element,
    });
  };

  elementorFrontend.hooks.addAction(
    "frontend/element_ready/ecf_Supporting.default",
    addHandler
  );
});
